export default {
   // 76px 600
  title: "text-4xl md:text-[54px] lg:text-[62px] xl:text-[70px] text-text leading-none tracking-tight font-extrabold",

  // 52px 900
  h1: "text-4xl md:text-5xl lg:text-[56px] text-text leading-none tracking-tight font-black",

  // 36px 700
  h2: "text-[28px] md:text-[32px] lg:text-[36px] text-text leading-tight tracking-tight font-bold",

  // 28px 700
  h3: "text-[22px] md:text-[24px] lg:text-[28px] text-text leading-tight tracking-tight font-bold",

  //22 px 700
  h4: "text-[18px] lg:text-[22px] text-text leading-tight tracking-tight font-bold",

  // 20px 400
  body1: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-normal",

  // 20px 400 gray
  body1_dim: "text-[16px] md:text-[17px] lg:text-[20px] text-text_secondary leading-normal font-normal",

  // 20px 500
  body1_medium: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-semibold",

  // 20px 700
  body1_accent: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-bold",

  // 16px 400 text color is defined per case 
  txt: "text-[15px] md:text-[16px] leading-tight font-normal",

  // 16px 600 text color is defined per case 
  txt_accent: "text-[15px] md:text-[16px] leading-tight font-semibold",

  // 16px 400 gray
  txt_dim: "text-[15px] md:text-[16px] text-text_secondary leading-tight font-normal",

  // 14px 400 text color is defined per case 
  txt1: "text-[14px] leading-tight font-normal",

  // 14px 600 text color is defined per case 
  txt1_accent: "text-[14px] leading-tight font-semibold",

  // 14px 400 gray
  txt1_dim: "text-[14px] text-text_secondary leading-tight font-normal",

  // 12px 400 text color is defined per case 
  txt2: "text-[12px] leading-tight font-normal",

  // 12px 600 text color is defined per case 
  txt2_accent: "text-[12px] leading-tight font-semibold",

  // 12px 400 gray
  txt2_dim: "text-[12px] text-text_secondary leading-tight font-normal",

  // 14px 400 text color is defined per case 
  label: "text-[14px] leading-tight font-normal mt-0 mb-1.5",

  // 14px 600 text color is defined per case 
  label_accent: "text-[14px] text-text leading-tight font-semibold mt-0 mb-1.5",

  // 14px 400 text color is defined per case 
  label_dim: "text-[14px] text-text_secondary leading-tight font-normal mt-0 mb-1.5",

  // 14px 400 uppercase primary color 
  label_upper_primary: "text-[14px] text-primary text-center font-bold uppercase tracking-widest mt-0 mb-2",

  label_upper_dim: "text-[12px] text-text_secondary font-normal uppercase tracking-wide leading-tight mt-0 mb-1",

  // 14px 400
  footer_item: "text-sm text-neutral_2 hover:text-white whitespace-nowrap transition-colors my-0",

  footer_group_label: "text-[10px] lg:text-[12px] font-medium uppercase tracking-wide md:tracking-widest text-neutral_1 my-0",

  // 17px 400 gray / primary
  breadcrumbs: "text-[16px] lg:text-[17px] leading-tight font-normal text-text_secondary hover:text-primary my-0",

  // error
  error: "text-[14px] text-red-500 leading-tight font-normal",
}
